import {listInstrumentTypes} from 'instruments/connections/ConnectionDAO';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getConnectionAdapterMenuOptionDatas(): Promise<Array<OptionData>> {
  return listInstrumentTypes().then(({instrumentAdapters}) =>
    instrumentAdapters.map((adapter) => ({
      name: adapter.displayName,
      value: adapter.id,
    }))
  );
}
